var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container"},[_c('LineChartBase',{attrs:{"chart-data":_vm.compData,"options":{responsive: true,animation: {duration: 2000}, maintainAspectRatio: false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }